import classNames from 'classnames';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheck, PiEye, PiUserCircle } from 'react-icons/pi';
import { usePutReadMessage } from 'services/chat';
import { IChatMessage } from 'services/chat/types';
import { useGetOwnerLogo } from 'services/settings/individual/logo';
import { formatMessageDate } from 'utils/global/date.utils';
import AttachmentsCard from '../attachments/AttachmentsCard';
import './MessageCard.scss';

interface IMessageCardProps {
  message: IChatMessage;
  recepientId: string;
  recepientName?: string;
}

const MessageCard = ({
  message,
  recepientId,
  recepientName,
}: IMessageCardProps) => {
  const { t } = useTranslation();
  const ownerLogo = useGetOwnerLogo();
  const isOwner = useMemo(
    () => message.recipientId === recepientId,
    [message.recipientId, recepientId],
  );

  const className = classNames(['message-card-wrapper'], {
    isOwner,
  });

  // const readMessage = usePutReadMessage();

  // const onReadMessage = async () =>
  //   readMessage.mutateAsync({
  //     messageId: message.id,
  //   });

  // useEffect(() => {
  //   if (message.readAt === null && !isOwner) {
  //     onReadMessage();
  //   }
  // }, [undefined, isOwner, message.id, message.readAt]);

  return (
    <div className={className}>
      <div className='message-card-profile'>
        {!isOwner ? (
          <PiUserCircle />
        ) : (
          <img src={ownerLogo.data?.pictureLink} alt='' />
        )}
      </div>
      <div className='message-card'>
        <div className='message-card-created'>
          {!isOwner && `${recepientName}  `}
          {formatMessageDate(message.messageCreatedAt)}
        </div>
        {!!message.attachments.length && (
          <div className='message-card-attachemnts'>
            {message.attachments.map(a => (
              <AttachmentsCard key={a.id} attachment={a} backgroundColor />
            ))}
          </div>
        )}
        <div
          className='message-card-text message-text'
          dangerouslySetInnerHTML={{ __html: message.body }}
        />
        {isOwner && (
          <div
            className='message-card-read'
            title={formatMessageDate(
              message.readAt ? message.readAt : message.messageCreatedAt,
            )}>
            {message.readAt ? (
              <>
                {t('support.read')} <PiEye />
              </>
            ) : (
              <>
                {t('support.sent')} <PiCheck />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageCard;
